import { AppApiFactory } from '~/plugins/api/app-api-factory'

export class DlcApiFactory extends AppApiFactory {
  get _baseUrl() {
    return this._config.API_DLC
  }
}
